const config = {
    API_URL: 'https://app.myrudder.fr/api/',
};

export default config;
